<template>
    <div>
        <h2 v-show="filters.length" class="report__title">{{ translations.filters }}</h2>
        <div v-if="filters">
            <div :class="radioFilters.length ? 'report__filter-items--short' : 'report__filter-items'">
                <div class="report__filter-item--short" v-for="filter in radioFilters" :key="filter.name">
                    <DataTableFilterRadio v-bind="filter" v-model="query[filter.name]" />
                </div>

                <div v-for="filter in selectFilters" :key="filter.name"
                    :class="filter.style === 'short' ? 'report__filter-item--short' : 'report__filter-item'">
                    <DataTableFilter v-bind="filter" v-model="query[filter.name]" />
                </div>

                <div class="report__filter-item">
                    <label class="form__control">
                        <span class="form__label">Search</span>
                        <input placeholder="Search here" class="form__input" v-model="searchQuery"
                            @keyup="reloadData" />
                    </label>
                </div>
            </div>
        </div>

        <table ref="datatable" class="striped nowrap order-column" width="100%" v-once>
            <thead>
                <tr>
                    <th v-for="column in columns" :key="column.name">{{ column.label }}</th>
                </tr>
            </thead>
            <tbody></tbody>
        </table>

        <div v-if="hasCSV" class="text-right">
            <form :action="csvURL" method="POST">
                <CSRFToken />
                <input type="hidden" name="json" :value="jsonParams" />
                <div class="btn-group">
                    <button class="button--secondary-alt--secondary">{{ csv.caption }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>
import {ref, computed, onMounted, useTemplateRef, watch, watchEffect} from 'vue';
import $ from 'jquery';
import axios from 'axios';
import DataTable from 'datatables';

import DataTableFilter from './DataTableFilter.vue';
import DataTableFilterRadio from './DataTableFilterRadio.vue';
import CSRFToken from './CSRFToken.vue';

const props = defineProps({
    columns: {
        type: Array,
        required: true,
        default: () => [],
    },
    ajax: {
        type: String,
        default: () => window.location.href,
    },
    filters: {
        type: Array,
        default: () => [],
    },
    order: {
        type: Array,
        default: () => [],
    },
    translations: Object,
    csv: {
        type: [Object, null],
        default: null,
    },
})

const datatable = useTemplateRef('datatable');
const query = ref(props.filters.reduce((acc, filter) => {
	acc[filter.name] = filter.type === 'select' ? [] : null;
	return acc;
},{}))



const searchQuery = ref('')
const params = ref({})
let table = null

const radioFilters = computed(() => props.filters.filter(f => f.type === 'radio'))
const selectFilters = computed(() => props.filters.filter(f => f.type === 'select'))
const hasCSV = computed(() => props.csv !== null)
const csvURL = computed(() => (hasCSV.value ? props.csv.url : null))
const jsonParams = computed(() => JSON.stringify(params.value))

onMounted(() => {
    initDataTables()
    $(datatable.value).on('click', '[data-ajax]', ajaxRequest)
})

watch(query,(newQuery)=>{
	reloadData();

},{ deep: true })

function initDataTables() {
    table = $(datatable.value).DataTable({
        processing: false,
        serverSide: true,
        ajax: {
            url: props.ajax,
            data: serverData,
        },
        order: getOrder(),
        columns: props.columns.map(column => ({
            ...column,
            data: column.data || column.name,
        })),
        bFilter: false,
        pageLength: 25,
        language: Object.assign({ paginate: { next: '', previous: '' } }, props.translations),
        scrollX: true,
    })

    table.on('xhr', updateParams)
}

function serverData(data) {
    data.filters = query.value
    data.search.value = searchQuery.value
    return data
}


function reloadData() {
    table.ajax.reload()
}

function getOrder() {
    return props.order.map(([name, direction]) => {
        return [props.columns.findIndex(column => column.name === name), direction]
    })
}

function ajaxRequest(e) {
    const $button = $(e.currentTarget)
    const url = $button.data('ajax')

    axios.post(url).then(() => {
        reloadData()
    })
}

function updateParams() {
    params.value = table.ajax.params()
	// The backed will restrict the number of results if this is set which we dont want when we are downloading a csv
    params.value.length = null
}
</script>
